const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const AT = require("../core/vault/ActionTypes");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const styles = require("./styles/EmailInput.css");
const Analytics = require("../core/util/Analytics");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "EmailInput",

		propTypes: {
			sectionName: PT.string.isRequired,
			backgroundType: PT.oneOf(["onWhite", "onRed", "onBlue", "bottomBar"])
				.isRequired,
			size: PT.oneOf(["smaller", "small", "large"]).isRequired,
			extraClass: PT.string,
			inputClass: PT.string,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {email: ""};
		},

		onSubmit: function() {
			this.props.dispatch({
				type: AT.BEGIN_EMAIL_SIGN_UP,
				email: this.state.email,
			});
			this.setState({email: ""});
		},

		handleKeyPress: function(evt) {
			if (evt.which === 13) {
				this.onSubmit();
			}
		},

		handleChange: function(evt) {
			this.setState({email: evt.target.value});
		},

		render: function() {
			const {
				size,
				backgroundType,
				extraClass,
				sectionName,
				inputClass,
			} = this.props;
			const mainClass = [
				styles.entry,
				styles[size],
				styles[backgroundType],
				extraClass,
			].join(" ");
			const submitColorClass = styles[backgroundType + "Submit"];
			return (
				<div className={mainClass}>
					<input
						name="email"
						className={styles.input + (inputClass ? " " + inputClass : "")}
						type="text"
						placeholder="Your email"
						value={this.state.email}
						onChange={this.handleChange}
						onKeyPress={this.handleKeyPress}
						autoComplete={"section-" + sectionName}
						{...Analytics.getHotjarSuppressionAttributes()}
					/>
					<div
						className={styles.submit + " " + submitColorClass}
						onClick={this.onSubmit}
					>
						<img
							className={styles.icon}
							alt="Sign Up for Updates"
							src={
								global.BASE_URL +
								"assets/images/office/elements/arrow-right-white.svg"
							}
						/>
					</div>
				</div>
			);
		},
	})
);
